import { ElementRef, Component, Input } from '@angular/core'

import { animate, style, transition, trigger, state } from '@angular/animations'
import { IconImageService } from '../shared/services/icon-image.service'

@Component({
    selector: 'app-drop-down-service',
    template: `
    <div class="setup-container" [@dropDown]="state" (@dropDown.done)="onAnimationDone()">
      <div *ngIf="!disableDropDown" class="setup-title disable-selection" (click)="onExpand(expandImage)">
        {{ menuTitle }}
        <span *ngIf="!expand.show" class="dropdown-closed-status-bar">
          <span class="subtitle right-spacing" [style.color]="Black">Services: {{ services }}</span>
          <span class="subtitle right-spacing" [style.color]="Black">
            Status:
            <span class="image-container">
              <img class="grey-img icon" *ngIf="services === 0" [src]="iconService.Icon.minus_1_5" />
              <img class="red-img icon" *ngIf="statusColor === 'Red' && services !== 0" [src]="iconService.Icon.cross_1_5" />
              <img class="yellow-img icon" *ngIf="statusColor === 'Yellow' && services !== 0" [src]="iconService.Icon.exclamation_mark_1_5" />
              <img class="green-img icon" *ngIf="statusColor === 'Green' && services !== 0" [src]="iconService.Icon.check_1_5" />
            </span>
          </span>
        </span>
        <span class="expand">
          <img class="expand-image disable-selection" #expandImage id="expandImage" name="expandImage" [src]="iconService.Icon.down_1" />
        </span>
      </div>
      <div [ngClass]="maxHeight ? 'max-height' : ''">
        <ng-content></ng-content>
      </div>
    </div>
  `,
    styles: [
        `
      .setup-container {
        width: 100%;
        background-color: white;
        border-radius: 20px;
        padding: 32px 25px 25px 25px;
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        box-shadow: 1px 1px 6px 0px rgba(34, 34, 34, 0.08);
      }
      .image-container {
        width: 30%;
        height: 30%;
      }
      .max-height {
        overflow: hidden;
      }
      .icon {
        width: 20px;
        height: 20px;
      }
      .setup-title {
        font-family: 'Poppins-Regular';
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0.5px;
        padding: 32px 32px;
        margin: -32px -32px 0px -32px;
        color: var(--statusColor, black);
        cursor: pointer;
        display: flex;
      }
      .disable-selection {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
      .expand-image {
        transform: rotate(180deg);
      }
      .expand {
        margin-left: auto;
      }
      .subtitle {
        width: 150px;
        height: 19px;
        font-family: Lato;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.19;
        letter-spacing: 0.1px;
        color: #333333;
      }
      hr {
        display: block;
        margin-top: 0.1em;
        margin-bottom: 0;
        margin-left: auto;
        margin-right: auto;
        border-style: inset;
        border-width: 1px;
        background-color: #c8c7cc;
        width: 100%;
        margin: 16px 0 0 0;
      }
      .dropdown-closed-status-bar {
        padding-left: 15px;
        display: flex;
        align-items: center;
        gap: 4px;
      }
      .right-spacing {
        padding-right: 10px;
      }
      .red-img {
        filter: invert(65%) sepia(39%) saturate(2979%) hue-rotate(314deg) brightness(84%) contrast(116%);
      }
      .green-img {
        filter: invert(66%) sepia(7%) saturate(2836%) hue-rotate(110deg) brightness(98%) contrast(80%);
      }
      .yellow-img {
        filter: invert(87%) sepia(6%) saturate(3162%) hue-rotate(348deg) brightness(99%) contrast(105%);
      }
      .grey-img {
        filter: invert(71%) sepia(0%) saturate(0%) hue-rotate(289deg) brightness(94%) contrast(90%);
      }
    `,
    ],
    animations: [trigger('dropDown', [state('initial', style({ height: '90px' })), state('final', style({ height: '*' })), transition('initial=>final', animate('150ms ease-out')), transition('final=>initial', animate('150ms ease-out'))])],
    standalone: false
})
export class DropDownServiceComponent {
  @Input() menuTitle: string
  @Input() disableDropDown = false
  @Input() hrEnabled = false
  @Input() statusColor: string
  @Input() services: number

  public maxHeight = false
  public state = 'final'
  public expand = { show: true }

  constructor(
    private element: ElementRef,
    public iconService: IconImageService,
  ) {}

  onExpand(image) {
    this.expand.show = !this.expand.show
    image.style.transform = `rotate(${this.expand.show ? 180 : 0}deg)`
    this.state = this.state === 'initial' ? 'final' : 'initial'
    if (this.state === 'initial') {
      this.maxHeight = true
    }
  }

  onAnimationDone() {
    if (this.state === 'final') {
      this.maxHeight = false
    }
  }
}
